/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M9.057 5.33a4.162 4.162 0 1 1 4.373 6.85 6.958 6.958 0 0 1 5.527 6.81.9.9 0 0 1-1.8 0 5.158 5.158 0 1 0-10.315 0 .9.9 0 0 1-1.8 0 6.958 6.958 0 0 1 5.527-6.81 4.16 4.16 0 0 1-2.731-3.908c0-1.104.438-2.162 1.219-2.943ZM12 5.91a2.362 2.362 0 1 0 0 4.724 2.362 2.362 0 0 0 0-4.724Z"
})), "0 0 24 24", "UserSingleLight");